import { render, staticRenderFns } from "./appTab.vue?vue&type=template&id=3e4e88ff&"
import script from "./appTab.vue?vue&type=script&lang=js&"
export * from "./appTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports